import { fetchData, APIMethod, ACCESS_DOMAINS } from "@client";

export async function getUsersQuery(projectId) {
  return await fetchData(`api/get-jira-users`, APIMethod.POST, {
    baseURL: ACCESS_DOMAINS.btApi,
    data: { project_id: projectId },
  });
}
